import type { InputHTMLAttributes } from 'react';
import { createContext } from 'react';

export interface RadioGroupContext {
  name: string
  value: string
  onChange: InputHTMLAttributes<HTMLInputElement>['onChange']
}

export const RadioGroupContext = createContext<RadioGroupContext>({
  name: null,
  value: undefined,
  onChange: undefined,
})
